addEventListener('DOMContentLoaded', () => {
	const mobileHome = document.body.classList.contains('home') && window.innerWidth <= 768
	const hero = document.body.querySelector('#hero')
	if (!hero || mobileHome) {
		return
	}

	const images = hero.querySelectorAll('.images > div, ui-carousel ui-carousel-blocks ui-carousel-block')

	const buttonsHolder = hero.querySelector('.buttons')
	const buttons = buttonsHolder.querySelectorAll('a')

	const SLIDESHOW_DURATION = 5000 // ms
	let interval = null
	let currentIndex = 0

	const highlight = (index) => {
		for (let a = 0; a < buttons.length; a++) {
			if (a == index) {
				buttons[a].classList.add('active')
				images[a] && images[a].classList.add('active')
			}
			else {
				buttons[a].classList.remove('active')
				images[a] && images[a].classList.remove('active')
			}
		}
		currentIndex = index
	}

	// Automated slideshow.
	const stopSlideshow = () => clearInterval(interval)

	const startSlideshow = () => {
		stopSlideshow()
		interval = setInterval(() => {
			const next = (currentIndex + 1) % buttons.length
			highlight(next)
		}, SLIDESHOW_DURATION)
	}

	// Mouse events.
	for (let a = 0; a < buttons.length; a++) {
		const index = a
		buttons[a].addEventListener('mouseenter', () => {
			stopSlideshow()
			highlight(index)
		})
	}

	buttonsHolder.addEventListener('mouseleave', () => {
		startSlideshow()
	})

	highlight(0)
	startSlideshow()
})